let errorCode = {};
errorCode[10001] = 'Server busy or system error,Operation failed.Please check internet connection or try later.',
errorCode[11001] ='Post information error'
errorCode[11002]='Creat token of authority faild.Please close and re-open APP and try again.'
errorCode[11003]='The verification code is incorrect.'
errorCode[11004]='Email or password is error'
errorCode[11005]='Sorry,the email address is incorrect, email must include "@" character,can not include "~!#$%^&*()+=^" and other illegal characters.'
errorCode[11006]='The password must be between 6 to 20 characters.'
errorCode[11007]='Lack token of authority.Please close and re-open APP and try again.'
errorCode[11008]='Token of authority is error.Please close and re-open APP and try again.'
errorCode[11009]='Login expired, please login again'
errorCode[11010]='Upload failed'
errorCode[11011]='Server busy or system error,Operation failed.Please check internet connection or try later.'
errorCode[12001]='Device is not registered'
errorCode[12002]='This device has been bound by other user.'
errorCode[12003]='Schedule mode not exist'
errorCode[12004]='Device Initialization error'
errorCode[12005]='Device is not active, disbind it failed.'
errorCode[12018]='This product model has generated an order and cannot be modified.'//0804 add
errorCode[13001]='User is not exist'
errorCode[13002]='Password has been changed succeefully.'
errorCode[13003]='This email has been registered.'
errorCode[13004]='Important update on cloud server, Please update phone APP.'
errorCode[14001]='User group is already exist,Try other name again.'
errorCode[14002]='Product group is already exist,Try other name again.'
errorCode[14003]='Can not delete group that exist product.'
errorCode[14004]='The new product group name is already exist,Try other name again.'
errorCode[14005]='Can not delete group that exist user.'
errorCode[14006]='Can not delete system user group'
errorCode[14007]='Can not rename system user group'
errorCode[14008]='The new user group name is already exist,Try other name again.'
errorCode[14009]='Refresh user group failed'
errorCode[14010]='Product type is already exist,Try other name again.'
errorCode[14011]='Refresh product group failed'
errorCode[14012]='Order Nr is already exist,Try other Nr again.'
errorCode[14013]='Old password is error,change password failed.'
errorCode[14014]='APP version Nr is already exist,Try other Nr again.'
errorCode[14015]='APP version must be newer than that exist.'
errorCode[14016]='This distributor is not exist.'
errorCode[14017]='APP version format is incorrect.'
errorCode[14018]='This APP version is not exist.'
errorCode[14019]='Can not creat update plan with expired version APP.'
errorCode[14020]='Delete App update plan failed.'
errorCode[14021]='The same version firmware is exist,please try with other firmware file.'
errorCode[14022]='Upload firmware version must be newer than exist.'
errorCode[14023]='Can not delete this firmware that included in update plan.'
errorCode[14024]='Delete firmware failed'
errorCode[14025]='Delete firmware update plan failed'
errorCode[14026]='Group name is already exist,please try other name.'
errorCode[14027]='Can not delete group that including devices.'
errorCode[14028]='Delete device group failed.'
errorCode[14029]='This email is already used, please try other email.'
errorCode[14030]='Can not delete this type that relate with orders.'
errorCode[14031]='Delete product failed.'
errorCode[14032]='Can not delete order that include devices.'
errorCode[14033]='Delete order failed.'
errorCode[14034]='This page number already exists'
errorCode[14035]='This page has been applied and cannot be deleted'
errorCode[14036]='Company MAC is blank, please input it in setting page.'

errorCode[14040]='The device group model does not match the model supported by the firmware package.'  //20211105
errorCode[15002]='Scheduled task exception.'  //20211105
errorCode[14042]='Abnormal firmware package file or directory.'  //2021 12 20

export default errorCode